(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookMergeItem', HandbookMergeItem);

    HandbookMergeItem.$inject = ['$resource', 'DateUtils'];

    function HandbookMergeItem ($resource, DateUtils) {
        var resourceUrl =  'api/handbook-merge-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.merged = DateUtils.convertDateTimeFromServer(data.merged);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
